export const configuration = {
    PAGESIZE: 15,
    PAGENUMBER: 1,
    PAGESIZES: [5,10,15,30,45]
}
